import { cn } from "@/lib/utils"

export type StatItem = {
  name: string
  value: string
  /** A change since last time, e.g. "+4.75%". */
  change?: string
  /** Whether the change is good news; colors it. */
  trend?: "up" | "down" | "flat"
}

/** Application UI "stats with trending": figures sharing hairline borders, so the grid reads as one panel. */
export function StatGrid({ stats, className, columns = 4 }: { stats: StatItem[]; className?: string; columns?: 3 | 4 }) {
  return (
    <dl
      className={cn(
        "grid grid-cols-1 gap-px overflow-hidden rounded-xl bg-hairline ring-1 ring-hairline sm:grid-cols-2",
        columns === 4 ? "lg:grid-cols-4" : "lg:grid-cols-3",
        className,
      )}
    >
      {stats.map((stat) => (
        <div key={stat.name} className="flex flex-wrap items-baseline justify-between gap-x-4 gap-y-2 bg-page px-4 py-8 sm:px-6">
          <dt className="text-sm/6 font-medium text-ink-muted">{stat.name}</dt>
          {stat.change && (
            <dd
              className={cn(
                "text-xs font-medium",
                stat.trend === "down" ? "text-danger-display" : stat.trend === "up" ? "text-accent-display" : "text-ink-body",
              )}
            >
              {stat.change}
            </dd>
          )}
          <dd className="w-full flex-none text-3xl/10 font-medium tracking-tight text-ink-display">{stat.value}</dd>
        </div>
      ))}
    </dl>
  )
}
